/**
 * Directive: formInput
 */
angular.module('acme.common.directive.formInput', [])
.directive('formInput', [function() {

    return {
      restrict: 'A',
      replace: true,
      transclude: true,
      templateUrl: 'common/directives/formInput/formInput.tpl.html',
      scope: {
        name: '@',
        label: '@',
        hideLabel: '@hidelabel',
        validTest: '=validtest',
        errorMessage: '=errormessage',
        isPanelGroup: '@ispanelgroup',
        placeholderValue: '@placeholdervalue',
        removeLabel: '@',
        srOnly: '@'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.formInput = {
          placeholder: $scope.placeholderValue || $scope.label,
          groupTypeClass: ($scope.isPanelGroup) ? 'panel-form-group' : 'form-group',
          checkValid: function() {
            return ($scope.validTest !== undefined) ? $scope.validTest : true;
          }
        };

      }]

    };

}]);